var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.4929 0C4.25012 0 0 4.25012 0 9.4929C0 11.872 0.875156 14.0466 2.3211 15.7125C3.97294 17.6156 6.13152 19.082 7.64706 21.0953L9.26513 23.8692C9.36689 24.0436 9.61892 24.0436 9.72068 23.8692L11.3387 21.0953C12.8543 19.082 15.0129 17.6156 16.6647 15.7125C18.1107 14.0466 18.9858 11.872 18.9858 9.4929C18.9858 4.25012 14.7357 0 9.4929 0Z",
  fill: "#EA503F"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.49291,
  cy: 9.49267,
  r: 3.1643,
  fill: "white"
});

function SvgMappin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappin);
export default __webpack_public_path__ + "static/media/mappin.0058dcdf.svg";
export { ForwardRef as ReactComponent };